var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_46_598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 125,
    height: 125
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_46_598)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 75,
    height: 75,
    rx: 4,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8478 87H39.5038V54.552H48.8478V87ZM48.0158 41.304C49.0824 42.3707 49.6158 43.6507 49.6158 45.144C49.6158 46.6373 49.0824 47.9173 48.0158 48.984C46.9491 50.0507 45.6691 50.584 44.1758 50.584C42.6824 50.584 41.4024 50.0507 40.3358 48.984C39.2691 47.9173 38.7358 46.6373 38.7358 45.144C38.7358 43.6507 39.2691 42.3707 40.3358 41.304C41.4024 40.2373 42.6824 39.704 44.1758 39.704C45.6691 39.704 46.9491 40.2373 48.0158 41.304ZM86.6313 87H77.2873V67.672C77.2873 65.752 76.8393 64.3013 75.9433 63.32C75.0473 62.296 73.7886 61.784 72.1673 61.784C70.4606 61.784 69.0313 62.4667 67.8793 63.832C66.7699 65.1547 66.2153 67.16 66.2153 69.848V87H56.8713V54.552H66.2153V60.056C67.0259 58.264 68.2633 56.856 69.9272 55.832C71.6339 54.7653 73.6606 54.232 76.0073 54.232C79.3353 54.232 81.9379 55.2347 83.8153 57.24C85.6926 59.2027 86.6313 62.104 86.6313 65.944V87Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/LinkedInLogo.aec977e351e0a7afe5f12e783e11e5f3.svg";
export { ForwardRef as ReactComponent };